import {IcnInfo} from "../../assets/icons";

interface FormGroupErrorTextProps {
  text?: string
}
function FormGroupErrorText({text}:FormGroupErrorTextProps) {
  return (
    <small className="c-form-group-error">
      <i><IcnInfo/></i>
      {text}
    </small>
  )
}

export default FormGroupErrorText
